import type { RecentHandSummary } from "../types.js";
import { CardView } from "./CardView.js";

interface RecentHandsBarProps {
  hands: readonly RecentHandSummary[];
  onSelect: (id: number) => void;
}

export function RecentHandsBar({ hands, onSelect }: RecentHandsBarProps) {
  if (hands.length === 0) return <div className="recent-hands-bar recent-hands-empty">直近ハンドなし</div>;
  return (
    <div className="recent-hands-bar">
      {hands.map((h) => (
        <button
          key={h.key}
          type="button"
          className="recent-hand-item"
          onClick={() => {
            if (h.id !== null) onSelect(h.id);
          }}
        >
          <div className="recent-hand-cards">
            <CardView card={h.holeCards[0]} size="sm" />
            <CardView card={h.holeCards[1]} size="sm" />
          </div>
          <span className={`recent-hand-result ${h.netBb >= 0 ? "result-win" : "result-loss"}`}>
            {h.netBb >= 0 ? "+" : ""}
            {h.netBb.toFixed(1)}bb
          </span>
        </button>
      ))}
    </div>
  );
}
